<template>
    <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        :color="color"
        :right="true"
        :multi-line="true"
        :bottom="true"
    >
        <v-icon color="white" class="mr-3">
            {{ icon }}
        </v-icon>
        <span v-html="text"></span>

        <v-btn text @click="snackbar = false">
            <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
    </v-snackbar>
</template>

<script>
export default {
    data: () => ({
        snackbar: false,
        text: null,
        timeout: 5000,
        color: null,
        icon: null,
    }),

    methods: {
        showNotification(type, text) {
            this.color = type
            this.text = text
            this.icon = this.getIconFromType(type)

            this.snackbar = true
        },

        getIconFromType(type) {
            switch (type) {
                case 'success':
                    return 'mdi-check-box-outline'

                case 'error':
                    return 'mdi-alert-box-outline'

                case 'warning':
                    return 'mdi-alert-box-outline'

                default:
                    return ''
            }
        },
    },

    mounted() {
        this.$bus.$on('notify', this.showNotification)
    },

    beforeDestroy() {
        this.$bus.$off('notify', this.showNotification)
    },
}
</script>
